import type { ReactNode } from "react";
import type { OnlineOrderOrderedBy } from "@/lib/api/types";
import { useTranslate } from "@/lib/i18n";

/**
 * «طلبه: ⟨name⟩ · ⟨****1234⟩» — WHO ORDERED a delivery sent for someone else
 * (B7, E-5). The contact everywhere else is the RECIPIENT, the person the
 * cashier and the driver call; this line only names the orderer, phone masked.
 *
 * One component for the request card, the PAPER bill head and the bill's
 * customer block, so the three read alike. The name and the masked phone are
 * separate isolates — the phone LTR — so an Arabic line cannot reorder
 * `****1234`. `trailing` carries anything that belongs to the ORDERER (the
 * card's "verified number" chip: it is the orderer's phone that was proven).
 */
export function OrderedByLine({
  orderedBy,
  testId,
  className = "text-[length:var(--font-size-xs)] font-semibold text-[color:var(--text-muted)]",
  trailing,
}: {
  orderedBy: OnlineOrderOrderedBy;
  testId: string;
  className?: string;
  trailing?: ReactNode;
}) {
  const t = useTranslate();
  return (
    <p data-ui="ordered-by" data-testid={testId} className={className}>
      {t((m) => m.pos.onlineOrderOrderedBy)} <bdi>{orderedBy.name}</bdi>
      {" · "}
      <bdi dir="ltr" className="tabular-nums">
        {orderedBy.phoneMasked}
      </bdi>
      {trailing ? <> {trailing}</> : null}
    </p>
  );
}
